import type { IntlKey } from 'locales';
import { FC } from 'react';
import { useIntl } from 'react-intl';

export type FeedbackMessageProps = Readonly<{
  labelKey: IntlKey;
  color: 'danger' | 'warning' | 'info';
}>;

export const FeedbackMessage: FC<FeedbackMessageProps> = ({ labelKey, color }) => {
  const { formatMessage } = useIntl();

  return (
    <small className={`text-${color}`}>
      <em className="icon icon-xs me-1">error_outline</em>
      {formatMessage({ id: labelKey })}
    </small>
  );
};
